/* global ApplePaySession */

import React, {useState,useContext,useRef,useEffect} from "react";

import { useNavigate  } from "react-router-dom";
import Lang from '../../../lang/translations';
import helpersFunction from "../../../_helpers/helpersFunction";
import ApplePayButton from 'apple-pay-button';
import PopupGenerico from '../../../popup/popupGenerico';

import applePay_functions from "./functions";

import Context from '../../../context/context';

const config = require("../../../_helpers/configServizi"); 


export default function ApplePay(props) {
    
       const context = useContext(Context)
      
        const onApplePayButtonClicked = async () => {
          const paymentRequest = {
            countryCode: config.servizi[window.location.hostname].apple_pay.country.toUpperCase(),
            currencyCode: config.servizi[window.location.hostname].apple_pay.valuta,
            total: {
              label: window.location.hostname,
              amount: context.rateplanScelto.prezzo_totale,
            },
            supportedNetworks: ["visa", "masterCard", "amex", "discover"],
            merchantCapabilities: ['supports3DS'],
          };
      


          const session = new ApplePaySession(1, paymentRequest);

   

          // ---- PASSO 1: CHIAMO ADYEN PER OTTENERE LA SESSIONE MERCHANT ----
          session.onvalidatemerchant = async (event) => {
            try {

              
              const d = new Date();
              const domain = window.location.hostname
  
              var data_request = {
                  country : config.servizi[window.location.hostname].apple_pay.country.toLowerCase(),
                  payment_company : config.servizi[domain].payment_company,
                  domain : window.location.hostname,
                  clickid : localStorage.getItem("trackerId"),
              }

              var res = await applePay_functions.getSessionFromBackend(data_request);
              console.log("Merchant validation response:", res);
              
              session.completeMerchantValidation(res);
              
            } catch (err) {
              console.error("Error merchant validation:", err);
              session.abort();
            }
          };


           // ---- PASSO 2: RICHIAMO ADYEN CON IL TOKEN PER CHIEDERE IL PAGAMENTO EFFETTIVO ----
          session.onpaymentauthorized = async (event) => {
            
            const applePayToken = event.payment.token;
            // Gestisci l'autorizzazione del pagamento

            console.log("Payment authorized with token:", applePayToken);
            
            const success = await chargeUser(applePayToken);
            if (success) {
              session.completePayment(ApplePaySession.STATUS_SUCCESS);
            } else {
              session.completePayment(ApplePaySession.STATUS_FAILURE);
            }
          };

          session.oncancel = function(event) {
            console.log('Apple Pay session cancelled.', event);

          };
      

          session.begin();
      };


        


        const chargeUser = async (applePayToken) => {

            const d = new Date();

            var data_request = {
                  country : helpersFunction.getCountry(),
                  rateplan : context.rateplanScelto,
                  payment_company : config.servizi[window.location.hostname].payment_company,
                  descriptor : config.servizi[window.location.hostname].descriptor,
                  payment_system : "applePay",
                  city : localStorage.getItem("city"),
                  clickid : localStorage.getItem("trackerId"),
                  domain : window.location.hostname,
                  email : context.email,
                  language: navigator.language,
                  screenHeight:window.screen.height,
                  screenWidth: window.screen.width,
                  timezone:d.getTimezoneOffset(),
                  userAgent: navigator.userAgent,
                  javaEnabled: true,
                  javascriptEnabled: true,
                  screenColorDepth: window.screen.colorDepth,
                  applePayToken: applePayToken,
                  pacchettone: context.flusso.rateplans?.pacchettone?.id
              }
            
            const response = await applePay_functions.chargeUser(data_request);
            console.log('Charge user response:', response);
            const contenuto = helpersFunction.contenuto_popop_pagamento(response.message)
            helpersFunction.showPopupgenerico("blocked",context,contenuto)

            if(response.message == "success"){
                setTimeout(function(){ 
                    context.Socket.emit('chat', context.messaggioPending);
                    context.setMessaggioPending(null);
                    window.location.replace("/chats");
                }, 3000);
                return true;
            }

          return false;
        };
      
        
          return  <div className="App" style={{marginTop:"15px",borderRadius: '5px',borderColor:"#000" , borderWidth:"1px" , borderStyle:"solid" }}>
            <ApplePayButton
              onClick={() => {
                console.log('Apple Pay button clicked');
                onApplePayButtonClicked();
              }}
              style={{ width: '100%', borderRadius: '8px', height: "44px" }}
              type="continue"
              buttonStyle="white"
            />
          </div>;
       
  
}